import { fetcher } from '@commenda/utils';

export function useDeletePaymentMethod(companyId: number) {
  const deletePaymentMethod = async (paymentMethodId: string) => {
    if (!companyId) {
      console.error('No company ID provided');
      return;
    }

    const url = `billing-new/payment-method?companyId=${companyId}&paymentMethodId=${paymentMethodId}`;
    const response = await fetcher(url, {
      method: 'DELETE',
    });

    if (!response.ok) {
      console.error('Failed to delete payment method:', response);
      return response;
    }

    return response;
  };

  return deletePaymentMethod;
}
